<template>
  <div class="score">
<v-alert outlined text dense color="purple"> この画面は作成中です。</v-alert>
    <h2>ポイントランキング</h2>

    <v-container>
      <v-row>
        <v-col>

          <v-simple-table>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">順位</th>
                <th class="text-left">名前</th>
                <th class="text-left">ポイント</th>
                <th class="">最終投稿</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(row,idx) in rankingList" :key="idx">
                <td>
                  <v-icon v-if="row.ranking === 1" color="yellow">mdi-crown</v-icon>
                  <span v-else class="px-2"></span>
                  {{"" + row.ranking + "位"}}
                </td>
                <td>{{ row.personName }}</td>
                <td>{{ row.point }}p</td>
                <td>{{ formatDateToDisplay(row.updateDate) }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>

        </v-col>
      </v-row>
    </v-container>

    <v-alert
        outlined
        color="blue"
        class="mx-11"
    >
      <div class="subtitle-1">
        ポイント取得条件
      </div>
      <div>
        ・新規の仕入先を投稿する 100pt <br>
        ・仕入先情報を更新する   50pt <br>
        ・クチコミを登録する     20pt <br>
        ・「いいね!」する       1pt
      </div>
    </v-alert>

  </div>
</template>
<script>
import ObjectParamSupport from "../../components/ObjectParamSupport";
import BaseView from "../../components/BaseView";
import PointrankingAPI from "@/apis/PointrankingAPI";

export default {
  mixins:[BaseView,ObjectParamSupport],
  components: {
  },
  props: [],
  data: () => ({
    isInitialized:false,
    isFetched:false,
    isLoading:false,
    isDownloading:false,

    //ranking:[
     // {
     //   staff_name:"沖野 つかさ",
     //   point:1100,
     //   last_post:"2020-10-23",
     // },
     // {
     //   staff_name:"霜上 かよ",
     //   point:980,
      //  last_post:"2020-08-01",
     // },
     // {
     //  staff_name:"前出 千尋",
     //   point:420,
     //   last_post:"2020-07-10",
     // },
     // {
     //   staff_name:"南口 宗太",
     //   point:210,
     //   last_post:"2020-10-27",
     // },
     // {
     //   staff_name:"墨谷 慎吾",
     //   point:200,
     //   last_post:"2020-10-20",
     // },
     // {
     //   staff_name:"能村 祥子",
     //   point:199,
     //   last_post:"2020-09-15",
     // }
    //],

    condition:{},

    rankingList:[
      {
        "ranking": 1,
        "personName": "下上",
        "point": 122,
        "updateDate": "2021-05-01T00:00:00"
      },
    ],

    pager:{},
    errors:{},
  }),
  computed: {

  },
  mounted:function() {
    this.setupConditions();
  },
  created:function() {
  },
  watch: {
    '$route':function (to, from) {
      this.setupConditions();
    },
  },
  methods: {
    setupConditions(){
      //let p = this.getObjectParam();
      //if (p){
        
      //}

      // パラメータの転写
        this.fetchData(true)
    },

    fetchData(needDataFetch){
      let self = this;
      if (!this.isInitialized){
        this.fetchBasicData(function () {
          self.fetchData(needDataFetch)
        });
        return;
      }
      if (needDataFetch){
        this.isLoading = true;
        Promise.resolve()
            .then(a => PointrankingAPI.pointRanking10())
            .then(data => {
              this.makeDisplayData(data);
            })
            .catch(function(err) {
              console.log(err);
              self.showErrorToast("データの取得に失敗しました。");
            });
      }
    },

    fetchBasicData(finishProc){
      this.isInitialized = true;
      if (finishProc){
        finishProc();
      }
    },

     makeDisplayData(data) {

          let self = this;

          this.logger.log("makeDisplayData", data)

          this.rankingList.splice(0) // もともと入ってた値をクリアする
        
          data.forEach(rec => { // dataをグルグル回す
            
            //let supplier = rec; // 変数に保存
            rec.isNew = true;
            this.rankingList.push(rec) // 表示用の配列に追加

          });
        }


  },

}
</script>